/* global window navigator */
import { useEffect } from 'react';
import cookie from '../../../helpers/cookies';
import { COOKIES } from 'Constants/constants';
import Auth from '../../Auth';
import { PLATFORM } from 'Constants/device.APP_TARGET';
import { UAParser } from 'ua-parser-js';

const LOGGER_INTERVAL_MS = 10000;
// eslint-disable-next-line no-magic-numbers
const MB_DIVISOR = 1024 * 1024;

const getMemoryUsage = () => {
    if (performance && performance.memory) {
        const { usedJSHeapSize, totalJSHeapSize } = performance.memory;

        return {
            used: Number((usedJSHeapSize / MB_DIVISOR).toFixed(2)),
            total: Number((totalJSHeapSize / MB_DIVISOR).toFixed(2))
        };
    }
    return 'Memory API not supported in this browser';
};

const useMemoryLogger = () => {
    const logMemoryUsage = () => {
        if (!window || !window.newrelic) {
            return;
        }

        const sessionId = cookie.readCookie(COOKIES.SESSION_ID.name);

        const user = Auth?.getUser();

        const parser = new UAParser(navigator.userAgent);
        const result = parser.getResult();

        const logData = {
            ...getMemoryUsage(),
            pageUrl: window.location.pathname,
            sessionId,
            userId: user?.id,
            platform: PLATFORM,
            deviceModel: result.device.model,
            browserName: result.browser.name,
            browserVersion: result.browser.version,
            osName: result.os.name,
            osVersion: result.os.version,
            engineName: result.engine.name,
            engineVersion: result.engine.version,
            cpu: result.cpu.architecture
        };

        window.newrelic.addPageAction('client_memory_usage', logData);
    };

    useEffect(() => {
        const interval = setInterval(() =>
            logMemoryUsage()
        , LOGGER_INTERVAL_MS);

        return () => clearInterval(interval);
    }, []);
};

export default useMemoryLogger;

